document.addEventListener("DOMContentLoaded", function () {
    function getVariantIdFromUrl() {
      const params = new URLSearchParams(window.location.search);
      return params.get("variant") || null;
    }
  
    let lastVariantId = getVariantIdFromUrl();
  
    // 🔥 Load related products when page opens
    reloadRelatedProducts();
  
    // 🔄 Periodically check for variant change
    setInterval(() => {
      const currentVariantId = getVariantIdFromUrl();
      if (currentVariantId !== lastVariantId) {
        lastVariantId = currentVariantId;
        console.log("Variant change detected! Reloading related products...");
        reloadRelatedProducts();
      }
    }, 500);
  
    function reloadRelatedProducts() {
      const container = document.getElementById("related-products-container");
      const currentProductHandle = window.location.pathname.split("/products/")[1]?.split("/")[0];
  
      if (!container) return;
  
      container.innerHTML = "<p>Caricamento prodotti correlati...</p>";
  
      fetch("/api/2023-04/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": "0eb954f508d19cef974f8464f4b5b44c",
        },
        body: JSON.stringify({
          query: `
            query GetProductMetafield($handle: String!) {
              productByHandle(handle: $handle) {
                metafield(namespace: "custom", key: "style_with") {
                  references(first: 10) {
                    edges {
                      node {
                        ... on Product {
                          id
                          handle
                          title
                          featuredImage {
                            url
                          }
                          priceRange {
                            minVariantPrice {
                              amount
                              currencyCode
                            }
                          }
                          variants(first: 1) {
                            edges {
                              node {
                                id
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          variables: { handle: currentProductHandle },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          const references = data?.data?.productByHandle?.metafield?.references.edges;
  
          if (!references || references.length === 0) {
            container.innerHTML = "<p>Nessun prodotto correlato trovato.</p>";
            return;
          }
  
          const productHTML = references.map((edge) => {
            const product = edge.node;
            const price = parseFloat(product.priceRange.minVariantPrice.amount).toFixed(2);
            const currencySymbol = product.priceRange.minVariantPrice.currencyCode === "EUR" ? "€" : product.priceRange.minVariantPrice.currencyCode;
  
            return `
              <div class="scroller-item">
                <a href="/products/${product.handle}" class="scroller-item__image-wrapper">
                  <img src="${product.featuredImage.url}" alt="${product.title}">
                </a>
                <div class="scroller-item__details">
                  <p class="scroller-item__title">${product.title}</p>
                  <p class="scroller-item__price">${currencySymbol}${price}</p>
                  <a href="/products/${product.handle}" class="scroller-item__view-details">Visualizza dettagli</a>
                </div>
              </div>
            `;
          }).join("");
  
          container.innerHTML = `<div class="custom-scroller">${productHTML}</div>`;
        })
        .catch((error) => {
          console.error("Errore nella ricarica dei prodotti correlati:", error);
          container.innerHTML = "<p>Errore nel caricamento dei prodotti correlati.</p>";
        });
    }
  });